// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
	border: 0;
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}
:root {
	--bg: #e3e4e8;
	--fg: #0d3e6f;
	--dur: 8s;
}
.loader {
	background: var(--bg);
	color: var(--fg);
	font: bold 1em/1.5 "Comfortaa", sans-serif;
	display: grid;
	place-items: center;
	align-content: center;
	height: 100vh;
	letter-spacing: 0.1em;
	text-transform: uppercase;
}
.hexagon {
	margin-bottom: 1.5em;
	overflow: hidden;
	position: relative;
	width: 15em;
	height: 15em;
}
.hexagon__group, .hexagon__sector, .hexagon__sector:before, .hexagon__sector:after {
	position: absolute;
}
.hexagon__group {
	width: 100%;
	height: 100%;
}
.hexagon__group:nth-child(2) .hexagon__sector,
.hexagon__group:nth-child(2) .hexagon__sector:before,
.hexagon__group:nth-child(2) .hexagon__sector:after {
	animation-delay: calc(var(--dur) * -1/6);
}
.hexagon__group:nth-child(3) .hexagon__sector,
.hexagon__group:nth-child(3) .hexagon__sector:before,
.hexagon__group:nth-child(3) .hexagon__sector:after {
	animation-delay: calc(var(--dur) * -2/6);
}
.hexagon__group:nth-child(4) .hexagon__sector,
.hexagon__group:nth-child(4) .hexagon__sector:before,
.hexagon__group:nth-child(4) .hexagon__sector:after {
	animation-delay: calc(var(--dur) * -3/6);
}
.hexagon__group:nth-child(5) .hexagon__sector,
.hexagon__group:nth-child(5) .hexagon__sector:before,
.hexagon__group:nth-child(5) .hexagon__sector:after {
	animation-delay: calc(var(--dur) * -4/6);
}
.hexagon__group:nth-child(6) .hexagon__sector,
.hexagon__group:nth-child(6) .hexagon__sector:before,
.hexagon__group:nth-child(6) .hexagon__sector:after {
	animation-delay: calc(var(--dur) * -5/6);
}
.hexagon__group:nth-child(odd) {
	transform: rotate(30deg);
}
.hexagon__sector, .hexagon__sector:before, .hexagon__sector:after {
	animation-duration: var(--dur);
	animation-iteration-count: infinite;
	animation-timing-function: linear;
	/*animation-play-state: paused;*/
	width: 0.2em;
	height: 0.2em;
}
.hexagon__sector {
	animation-name: moveOut1;
	top: calc(50% - 0.1em);
	left: calc(50% - 0.1em);
}
.hexagon__sector:nth-child(2) {
	animation-name: moveOut2;
}
.hexagon__sector:nth-child(3) {
	animation-name: moveOut3;
}
.hexagon__sector:nth-child(4) {
	animation-name: moveOut4;
}
.hexagon__sector:nth-child(5) {
	animation-name: moveOut5;
}
.hexagon__sector:nth-child(6) {
	animation-name: moveOut6;
}
.hexagon__sector:before, .hexagon__sector:after {
	animation-name: ripple;
	background-color: currentColor;
	border-radius: 0.1em;
	content: "";
	display: block;
	top: 0;
	left: 0;
	transform-origin: 0.1em 0.1em;
}
.hexagon__sector:before {
	transform: rotate(-30deg)
}
.hexagon__sector:after {
	transform: rotate(-150deg)
}
/* Dark theme */
@media (prefers-color-scheme: dark) {
	:root {
		--bg: #363795;
		--fg: #e3e4e8;
	}
}
/* Animations */
@keyframes moveOut1 {
	from { transform: translateY(0) scale(0); }
	3% { transform: translateY(0.2em) scale(1); }
	97% { transform: translateY(7.3em) scale(1); }
	to { transform: translateY(7.5em) scale(0); }
}
@keyframes moveOut2 {
	from { transform: rotate(60deg) translateY(0) scale(0); }
	3% { transform: rotate(60deg) translateY(0.2em) scale(1); }
	97% { transform: rotate(60deg) translateY(7.3em) scale(1); }
	to { transform: rotate(60deg) translateY(7.5em) scale(0); }
}
@keyframes moveOut3 {
	from { transform: rotate(120deg) translateY(0) scale(0); }
	3% { transform: rotate(120deg) translateY(0.2em) scale(1); }
	97% { transform: rotate(120deg) translateY(7.3em) scale(1); }
	to { transform: rotate(120deg) translateY(7.5em) scale(0); }
}
@keyframes moveOut4 {
	from { transform: rotate(180deg) translateY(0) scale(0); }
	3% { transform: rotate(180deg) translateY(0.2em) scale(1); }
	97% { transform: rotate(180deg) translateY(7.3em) scale(1); }
	to { transform: rotate(180deg) translateY(7.5em) scale(0); }
}
@keyframes moveOut5 {
	from { transform: rotate(240deg) translateY(0) scale(0); }
	3% { transform: rotate(240deg) translateY(0.2em) scale(1); }
	97% { transform: rotate(240deg) translateY(7.3em) scale(1); }
	to { transform: rotate(240deg) translateY(7.5em) scale(0); }
}
@keyframes moveOut6 {
	from { transform: rotate(300deg) translateY(0) scale(0); }
	3% { transform: rotate(300deg) translateY(0.2em) scale(1); }
	97% { transform: rotate(300deg) translateY(7.3em) scale(1); }
	to { transform: rotate(300deg) translateY(7.5em) scale(0); }
}
@keyframes ripple {
	from, to { width: 0.2em; }
	33% { width: 2.4em; }
}`, "",{"version":3,"sources":["webpack://./src/components/buttons/loading.css"],"names":[],"mappings":"AAAA;CACC,SAAS;CACT,sBAAsB;CACtB,SAAS;CACT,UAAU;AACX;AACA;CACC,aAAa;CACb,aAAa;CACb,SAAS;AACV;AACA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,0CAA0C;CAC1C,aAAa;CACb,mBAAmB;CACnB,qBAAqB;CACrB,aAAa;CACb,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,oBAAoB;CACpB,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;AACA;CACC,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,YAAY;AACb;AACA;;;CAGC,wCAAwC;AACzC;AACA;;;CAGC,wCAAwC;AACzC;AACA;;;CAGC,wCAAwC;AACzC;AACA;;;CAGC,wCAAwC;AACzC;AACA;;;CAGC,wCAAwC;AACzC;AACA;CACC,wBAAwB;AACzB;AACA;CACC,8BAA8B;CAC9B,mCAAmC;CACnC,iCAAiC;CACjC,gCAAgC;CAChC,YAAY;CACZ,aAAa;AACd;AACA;CACC,wBAAwB;CACxB,sBAAsB;CACtB,uBAAuB;AACxB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,sBAAsB;CACtB,8BAA8B;CAC9B,oBAAoB;CACpB,WAAW;CACX,cAAc;CACd,MAAM;CACN,OAAO;CACP,6BAA6B;AAC9B;AACA;CACC;AACD;AACA;CACC;AACD;AACA,eAAe;AACf;CACC;EACC,aAAa;EACb,aAAa;CACd;AACD;AACA,eAAe;AACf;CACC,OAAO,iCAAiC,EAAE;CAC1C,KAAK,qCAAqC,EAAE;CAC5C,MAAM,qCAAqC,EAAE;CAC7C,KAAK,qCAAqC,EAAE;AAC7C;AACA;CACC,OAAO,+CAA+C,EAAE;CACxD,KAAK,mDAAmD,EAAE;CAC1D,MAAM,mDAAmD,EAAE;CAC3D,KAAK,mDAAmD,EAAE;AAC3D;AACA;CACC,OAAO,gDAAgD,EAAE;CACzD,KAAK,oDAAoD,EAAE;CAC3D,MAAM,oDAAoD,EAAE;CAC5D,KAAK,oDAAoD,EAAE;AAC5D;AACA;CACC,OAAO,gDAAgD,EAAE;CACzD,KAAK,oDAAoD,EAAE;CAC3D,MAAM,oDAAoD,EAAE;CAC5D,KAAK,oDAAoD,EAAE;AAC5D;AACA;CACC,OAAO,gDAAgD,EAAE;CACzD,KAAK,oDAAoD,EAAE;CAC3D,MAAM,oDAAoD,EAAE;CAC5D,KAAK,oDAAoD,EAAE;AAC5D;AACA;CACC,OAAO,gDAAgD,EAAE;CACzD,KAAK,oDAAoD,EAAE;CAC3D,MAAM,oDAAoD,EAAE;CAC5D,KAAK,oDAAoD,EAAE;AAC5D;AACA;CACC,WAAW,YAAY,EAAE;CACzB,MAAM,YAAY,EAAE;AACrB","sourcesContent":["* {\n\tborder: 0;\n\tbox-sizing: border-box;\n\tmargin: 0;\n\tpadding: 0;\n}\n:root {\n\t--bg: #e3e4e8;\n\t--fg: #0d3e6f;\n\t--dur: 8s;\n}\n.loader {\n\tbackground: var(--bg);\n\tcolor: var(--fg);\n\tfont: bold 1em/1.5 \"Comfortaa\", sans-serif;\n\tdisplay: grid;\n\tplace-items: center;\n\talign-content: center;\n\theight: 100vh;\n\tletter-spacing: 0.1em;\n\ttext-transform: uppercase;\n}\n.hexagon {\n\tmargin-bottom: 1.5em;\n\toverflow: hidden;\n\tposition: relative;\n\twidth: 15em;\n\theight: 15em;\n}\n.hexagon__group, .hexagon__sector, .hexagon__sector:before, .hexagon__sector:after {\n\tposition: absolute;\n}\n.hexagon__group {\n\twidth: 100%;\n\theight: 100%;\n}\n.hexagon__group:nth-child(2) .hexagon__sector,\n.hexagon__group:nth-child(2) .hexagon__sector:before,\n.hexagon__group:nth-child(2) .hexagon__sector:after {\n\tanimation-delay: calc(var(--dur) * -1/6);\n}\n.hexagon__group:nth-child(3) .hexagon__sector,\n.hexagon__group:nth-child(3) .hexagon__sector:before,\n.hexagon__group:nth-child(3) .hexagon__sector:after {\n\tanimation-delay: calc(var(--dur) * -2/6);\n}\n.hexagon__group:nth-child(4) .hexagon__sector,\n.hexagon__group:nth-child(4) .hexagon__sector:before,\n.hexagon__group:nth-child(4) .hexagon__sector:after {\n\tanimation-delay: calc(var(--dur) * -3/6);\n}\n.hexagon__group:nth-child(5) .hexagon__sector,\n.hexagon__group:nth-child(5) .hexagon__sector:before,\n.hexagon__group:nth-child(5) .hexagon__sector:after {\n\tanimation-delay: calc(var(--dur) * -4/6);\n}\n.hexagon__group:nth-child(6) .hexagon__sector,\n.hexagon__group:nth-child(6) .hexagon__sector:before,\n.hexagon__group:nth-child(6) .hexagon__sector:after {\n\tanimation-delay: calc(var(--dur) * -5/6);\n}\n.hexagon__group:nth-child(odd) {\n\ttransform: rotate(30deg);\n}\n.hexagon__sector, .hexagon__sector:before, .hexagon__sector:after {\n\tanimation-duration: var(--dur);\n\tanimation-iteration-count: infinite;\n\tanimation-timing-function: linear;\n\t/*animation-play-state: paused;*/\n\twidth: 0.2em;\n\theight: 0.2em;\n}\n.hexagon__sector {\n\tanimation-name: moveOut1;\n\ttop: calc(50% - 0.1em);\n\tleft: calc(50% - 0.1em);\n}\n.hexagon__sector:nth-child(2) {\n\tanimation-name: moveOut2;\n}\n.hexagon__sector:nth-child(3) {\n\tanimation-name: moveOut3;\n}\n.hexagon__sector:nth-child(4) {\n\tanimation-name: moveOut4;\n}\n.hexagon__sector:nth-child(5) {\n\tanimation-name: moveOut5;\n}\n.hexagon__sector:nth-child(6) {\n\tanimation-name: moveOut6;\n}\n.hexagon__sector:before, .hexagon__sector:after {\n\tanimation-name: ripple;\n\tbackground-color: currentColor;\n\tborder-radius: 0.1em;\n\tcontent: \"\";\n\tdisplay: block;\n\ttop: 0;\n\tleft: 0;\n\ttransform-origin: 0.1em 0.1em;\n}\n.hexagon__sector:before {\n\ttransform: rotate(-30deg)\n}\n.hexagon__sector:after {\n\ttransform: rotate(-150deg)\n}\n/* Dark theme */\n@media (prefers-color-scheme: dark) {\n\t:root {\n\t\t--bg: #363795;\n\t\t--fg: #e3e4e8;\n\t}\n}\n/* Animations */\n@keyframes moveOut1 {\n\tfrom { transform: translateY(0) scale(0); }\n\t3% { transform: translateY(0.2em) scale(1); }\n\t97% { transform: translateY(7.3em) scale(1); }\n\tto { transform: translateY(7.5em) scale(0); }\n}\n@keyframes moveOut2 {\n\tfrom { transform: rotate(60deg) translateY(0) scale(0); }\n\t3% { transform: rotate(60deg) translateY(0.2em) scale(1); }\n\t97% { transform: rotate(60deg) translateY(7.3em) scale(1); }\n\tto { transform: rotate(60deg) translateY(7.5em) scale(0); }\n}\n@keyframes moveOut3 {\n\tfrom { transform: rotate(120deg) translateY(0) scale(0); }\n\t3% { transform: rotate(120deg) translateY(0.2em) scale(1); }\n\t97% { transform: rotate(120deg) translateY(7.3em) scale(1); }\n\tto { transform: rotate(120deg) translateY(7.5em) scale(0); }\n}\n@keyframes moveOut4 {\n\tfrom { transform: rotate(180deg) translateY(0) scale(0); }\n\t3% { transform: rotate(180deg) translateY(0.2em) scale(1); }\n\t97% { transform: rotate(180deg) translateY(7.3em) scale(1); }\n\tto { transform: rotate(180deg) translateY(7.5em) scale(0); }\n}\n@keyframes moveOut5 {\n\tfrom { transform: rotate(240deg) translateY(0) scale(0); }\n\t3% { transform: rotate(240deg) translateY(0.2em) scale(1); }\n\t97% { transform: rotate(240deg) translateY(7.3em) scale(1); }\n\tto { transform: rotate(240deg) translateY(7.5em) scale(0); }\n}\n@keyframes moveOut6 {\n\tfrom { transform: rotate(300deg) translateY(0) scale(0); }\n\t3% { transform: rotate(300deg) translateY(0.2em) scale(1); }\n\t97% { transform: rotate(300deg) translateY(7.3em) scale(1); }\n\tto { transform: rotate(300deg) translateY(7.5em) scale(0); }\n}\n@keyframes ripple {\n\tfrom, to { width: 0.2em; }\n\t33% { width: 2.4em; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
